import _ from "lodash";
import embeddingService from "services/embeddingService";

function hashify(path) {
    if (path[0] !== "#") {
        return "#" + path;
    } else {
        return path;
    }
}

export default {
    navigateTo: function (newPath, options) {
        options = _.assign({ newWindow: false }, options);
        embeddingService.requestNavigation(hashify(newPath), options);
    },
    redirectTo: function (newPath) {
        embeddingService.requestRedirect(hashify(newPath));
    },
    back: function () {
        embeddingService.notifyBackNavigation();
    },
};
